import { Component, ChangeDetectionStrategy, Input } from '@angular/core';
import { FlexLayoutType } from '../../constants/flex-layout.type';
import { StatusType } from '../../constants/status.type';
import { StatusTextType } from '../../constants/status-text.type';
import { HearingRequestDetailsModel } from '../../models/hearing-request-details.model';
import { HearingMethodType } from '../../constants/hearing-method.type';
@Component({
  selector: 'jsg-action-hearing-details-tile-view',
  templateUrl: './action-hearing-details-tile-view.component.html',
  styleUrls: ['./action-hearing-details-tile-view.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ActionHearingDetailsTileViewComponent {
  @Input() hearingRequest: HearingRequestDetailsModel;
  @Input() hearingDetailsRoute: string;

  public FlexLayoutType = FlexLayoutType;
  public StatusType = StatusType;
  public StatusTextType = StatusTextType;
  public HearingMethodType = HearingMethodType;

  constructor() {}
}
